"use strict";

exports.__esModule = !0, exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base")),
    _react = _interopRequireWildcard(require("react")),
    _util = require("../util"),
    PropTypes = _interopRequireWildcard(require("prop-types")),
    _constants = require("../constants");

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function () {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" != typeof a && "function" != typeof a) return {
    default: a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) if (Object.prototype.hasOwnProperty.call(a, e)) {
    var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
    f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
  }

  return c.default = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var Item = /*#__PURE__*/function (a) {
  function b() {
    for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) d[e] = arguments[e];

    return b = a.call.apply(a, [this].concat(d)) || this, _defineProperty(_assertThisInitialized(b), "item", _react.default.createRef()), b;
  }

  _inheritsLoose(b, a);

  var c = b.prototype;
  return c.componentDidUpdate = function componentDidUpdate() {
    this.props.state.cursor === this.props.itemIndex && this.item.current && this.item.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start"
    });
  }, c.render = function render() {
    var a = this.props,
        b = a.props,
        c = a.state,
        d = a.methods,
        e = a.item,
        f = a.itemIndex;
    return b.itemRenderer ? b.itemRenderer({
      item: e,
      itemIndex: f,
      props: b,
      state: c,
      methods: d
    }) : !b.keepSelectedInList && d.isSelected(e) ? null : _react.default.createElement(ItemComponent, {
      role: "option",
      ref: this.item,
      "aria-selected": d.isSelected(e),
      "aria-disabled": e.disabled,
      "aria-label": (0, _util.getByPath)(e, b.labelField),
      disabled: e.disabled,
      key: "" + (0, _util.getByPath)(e, b.valueField) + (0, _util.getByPath)(e, b.labelField),
      tabIndex: "-1",
      className: _constants.LIB_NAME + "-item " + (d.isSelected(e) ? _constants.LIB_NAME + "-item-selected" : "") + " " + (c.cursor === f ? _constants.LIB_NAME + "-item-active" : "") + " " + (e.disabled ? _constants.LIB_NAME + "-item-disabled" : ""),
      onClick: e.disabled ? void 0 : function () {
        return d.addItem(e);
      },
      onKeyPress: e.disabled ? void 0 : function () {
        return d.addItem(e);
      },
      color: b.color
    }, (0, _util.getByPath)(e, b.labelField), " ", e.disabled && _react.default.createElement("ins", null, b.disabledLabel));
  }, b;
}(_react.Component),
    ItemComponent = (0, _styledBase.default)("span", {
  target: "evc32pp0",
  label: "ItemComponent"
})("padding:5px 10px;cursor:pointer;border-bottom:1px solid #fff;&.", _constants.LIB_NAME, "-item-active{border-bottom:1px solid #fff;", function (a) {
  var b = a.disabled,
      c = a.color;
  return !b && c && "background: " + (0, _util.hexToRGBA)(c, .1) + ";";
}, "}:hover,:focus{background:", function (a) {
  var b = a.color;
  return b && (0, _util.hexToRGBA)(b, .1);
}, ";outline:none;}&.", _constants.LIB_NAME, "-item-selected{", function (a) {
  var b = a.disabled,
      c = a.color;
  return b ? "\n    background: #f2f2f2;\n    color: #ccc;\n    " : "\n    background: " + c + ";\n    color: #fff;\n    border-bottom: 1px solid #fff;\n    ";
}, "}", function (a) {
  var b = a.disabled;
  return b ? "\n    background: #f2f2f2;\n    color: #ccc;\n\n    ins {\n      text-decoration: none;\n      border:1px solid #ccc;\n      border-radius: 2px;\n      padding: 0px 3px;\n      font-size: x-small;\n      text-transform: uppercase;\n    }\n    " : "";
}, "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
    _default = Item;

exports.default = _default;